/* eslint-env browser */
export default (rootEl = document.body) => {
  setTimeout(() => {
    const el = rootEl.querySelector('h1,h2,h3');
    if (el) el.focus();
  }, 50);
};
